export const storefrontCategories = [
  {
    title: 'Racquet',
    description: 'Attack, control, and all-round frames for club players and competitors.',
    category: 'racquets',
    accent: 'Power Frames',
  },
  {
    title: 'String Type',
    description: 'Match your feel with repulsion, control, durability, and hybrid-focused strings.',
    category: 'strings',
    accent: 'Feel & Tension',
  },
  {
    title: 'Accessories',
    description: 'Grips, socks, wristbands, and practical add-ons for match day.',
    category: 'accessories',
    accent: 'Finish Your Setup',
  },
];

export const hotProducts = [
  {
    name: 'Yonex Astrox 88D Pro',
    category: 'racquets',
    label: 'Hot Pick',
    description: 'A head-heavy doubles frame for players who want strong rear-court pressure.',
  },
  {
    name: 'BG80 Power String',
    category: 'strings',
    label: 'Player Favorite',
    description: 'Crisp hitting feel with strong repulsion for aggressive badminton setups.',
  },
  {
    name: 'Tournament Grip Bundle',
    category: 'accessories',
    label: 'Fast Seller',
    description: 'A practical overgrip pack for players who refresh feel before every session.',
  },
];

export const newArrivals = [
  {
    name: 'Lining Aeronaut 9000C',
    category: 'racquets',
    label: 'New Arrival',
    description: 'Balanced handling with a fast frame profile for modern attacking play.',
    image: '/images/yonex-astrox88d.jpg',
  },
  {
    name: 'Exbolt 65 String',
    category: 'strings',
    label: 'Just In',
    description: 'Thin gauge response with quick shuttle hold and a lively string bed.',
    image: '/images/hero-bg-3.jpg',
  },
  {
    name: 'Court Day Essentials Pouch',
    category: 'accessories',
    label: 'Fresh Stock',
    description: 'A compact carry option for grips, tape, scissors, and small badminton tools.',
    image: '/images/hero-bg-2.jpg',
  },
];
